import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import "./assets/scss/style.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./translations/i18n";
import * as serviceWorker from "./serviceWorker";
import { colors } from "./utils/theme";
import nlNL from "antd/lib/locale/nl_NL";
import { ConfigProvider } from "antd";
import { PostHogProvider } from "posthog-js/react";
import { getPostHogClient } from "./helpers/posthogManager";
import { AuthContextProvider } from "./context/AuthContext";

const posthogClient = getPostHogClient();

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PostHogProvider client={posthogClient}>
      <AuthContextProvider>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: colors.primary,
              fontFamily: "",
            },
            components: {
              Button: {
                colorPrimary: colors.primary,
                colorBorder: colors.primary,
                borderColorDisabled: "#d9d9d9",
                colorTextLightSolid: "#fff",
                colorText: colors.primary,
                primaryShadow: "none",
              },
              Tree: {
                nodeSelectedBg: colors.primary30,
              },
              TreeSelect: {
                nodeSelectedBg: colors.primary30,
              },
              Select: {
                optionSelectedBg: colors.primary30,
              },
              Breadcrumb: {
                linkHoverColor: colors.primary,
              },
            },
          }}
          locale={nlNL}
        >
          <App />
        </ConfigProvider>
      </AuthContextProvider>
    </PostHogProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
